module.exports = __webpack_public_path__ + "media/images/solar-installer-22-b03d600b05243125ce728e863cd29d14.jpg";